import type { DataTableHeader } from '@/types/vuetify';

export function createTeamPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        // { title: t('team.id'), value: 'id', key: 'id', align: 'center', sortable: true, nowrap: true },
        { title: t('team.name'), value: 'name', key: 'name', align: 'start', sortable: true, nowrap: true },
        { title: t('team.sportId'), value: 'sportId', key: 'sportId', align: 'center', sortable: true, nowrap: true },
        // { title: t('team.internalId'), value: 'internalId', key: 'internalId', align: 'center', sortable: true, nowrap: true },
        { title: t('team.bookmakerId'), value: 'bookmakerId', key: 'bookmakerId', align: 'center', sortable: true, nowrap: true },
        { title: t('team.customTeamId'), value: 'customTeamId', key: 'customTeamId', align: 'start', sortable: true, nowrap: true },
        { title: t('team.gameCount'), value: 'gameCount', key: 'gameCount', align: 'center', sortable: true, nowrap: true },
        { title: '', value: 'actions', key: 'actions', align: 'end', sortable: false, nowrap: true, width: 24, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
